import { Flex, Box, Text, ScrollArea } from "@radix-ui/themes";
import { Button, Dialog, Label } from "../elements.js";
import { ApiKeyDetailsCard } from "./api-key-details-card.js";
import {
  ListOrganizationApiKeysResponseData,
  useListOrganizationApiKeyPermissions,
} from "../../api/endpoint.js";
import { Translation } from "../i18n/translation.js";

function Permission({
  ...permission
}: {
  name: string;
  description?: string | null;
}) {
  return (
    <Box className="woswidgets-api-key-details-permission" px="4" py="3">
      <Flex direction="column">
        <Text size="2" weight="bold">
          {permission.name}
        </Text>
        {permission.description ? (
          <Text size="2" color="gray">
            {permission.description}
          </Text>
        ) : null}
      </Flex>
    </Box>
  );
}

export function ApiKeyDetailsDialog({
  open,
  onOpenChange,
  apiKey,
  permissions,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  apiKey: ListOrganizationApiKeysResponseData;
  permissions: string[];
}) {
  const permissionsQuery = useListOrganizationApiKeyPermissions({ limit: 100 });
  const filteredPermissions = permissions.map((permission) =>
    permissionsQuery.data?.data.find((p) => p.slug === permission),
  );

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="529px">
        <Dialog.Title>
          <Translation
            defaultMessage="API key details"
            id="dqU4kt"
            description="Dialog title for viewing API key details"
          />
        </Dialog.Title>
        <Flex direction="column" gap="5">
          <ApiKeyDetailsCard apiKey={apiKey} mt="5" />
          {permissions.length ? (
            <Flex direction="column" gap="2">
              <Label>
                <Translation
                  defaultMessage="Permissions"
                  id="i0XUeg"
                  description="Label for API key permissions section"
                />
              </Label>
              <Flex
                style={{
                  borderRadius: "var(--radius-3)",
                  borderColor: "var(--gray-6)",
                  borderWidth: "1px",
                  borderStyle: "solid",
                }}
                direction="column"
                align="stretch"
              >
                <ScrollArea style={{ maxHeight: "calc(50vh - 150px)" }}>
                  {filteredPermissions.map((permission) => {
                    if (!permission) return null;
                    return <Permission key={permission.name} {...permission} />;
                  })}
                </ScrollArea>
              </Flex>
            </Flex>
          ) : null}
        </Flex>
        <Flex align="center" gap="3" justify="end" mt="5">
          <Dialog.Close>
            <Button variant="secondary">
              <Translation
                defaultMessage="Close"
                id="/4YwoE"
                description="Button to close the API key details dialog"
              />
            </Button>
          </Dialog.Close>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
